<template>
  <v-container class="payment-container">
    <v-expansion-panel popout light class="futuristic-expansion">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <h4 class="earth-color">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template v-slot:actions>
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color">Unticketed Booking Alerts</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                      v-model="search"
                      class="futuristic-search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="columns"
                    :items="getInspectedUnticketedAlerted"
                    :search="search"
                    :pagination.sync="pagination"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    class="futuristic-table">
        <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td data-label="Booking Reference">
            <span v-for="(booking, key) in props.item.update_bookings" :key="key">
              <router-link :to="{
                  name: 'Booking',
                  params: { booking_id: booking.booking_public_id },
                }"
                           target="_blank">
                <a class="futuristic-link">{{ booking.booking_ref_code }}, </a>
              </router-link>
            </span>
          </td>
          <td data-label="Destination">{{ props.item.destination }}</td>
          <td data-label="Adult">{{ props.item.adult }}</td>
          <td data-label="Children">{{ props.item.children }}</td>
          <td data-label="Vehicle Registration">{{ props.item.vehicle_registration }}</td>
          <td data-label="Alert">{{ props.item.note }}</td>
          <td data-label="Alert Date">{{ formated_date(props.item.created_at) }}</td>
          <td data-label="Action Taken" :style="props.item.booking_color">{{ props.item.action_taken }}</td>
          <td data-label="Action">
            <v-btn v-if="props.item.alert == 'true'"
                   :depressed="true"
                   color="#587e27"
                   @click="updateViewAlertUpdate(props.item.note_public_id)"
                   class="futuristic-btn">View/Update</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-select :items="rowsPerPageItems"
                      v-model="pagination.rowsPerPage"
                      label="Rows per page"
                      class="futuristic-input"></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-btn :depressed="true"
                 color="#587e27"
                 @click="getMore()"
                 :loading="this.$store.state.LoadingStore.loading"
                 class="futuristic-btn">GET MORE</v-btn>
          <v-btn :depressed="true"
                 color="#587e27"
                 @click="getAllUnticketedAlerts()"
                 :loading="this.$store.state.LoadingStore.loading"
                 class="futuristic-btn">GET ALL</v-btn>
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn :depressed="true"
                 color="#f1c40f"
                 @click="getAlerts"
                 :loading="$loadingTrue"
                 class="futuristic-btn">VIEW ALL ALERTS</v-btn>
          <vue-json-to-csv :json-data="getInspectedUnticketedCSV"
                           csv-title="Booking Unticketed Alerts"
                           :labels="{
              destination: { title: 'Destination' },
              adult: { title: 'Adult' },
              children: { title: 'Children' },
              vehicle_registration: { title: 'Vehicle Registration' },
              note: { title: 'Alert Details' },
              created_at: { title: 'Alert Date' },
              session_user: { title: 'Alert Raised By' },
              update_notes: { title: 'Action Taken' },
            }">
            <v-btn :depressed="true"
                   color="#f1c40f"
                   :loading="$loadingTrue"
                   class="futuristic-btn">Download Alerts(CSV)</v-btn>
          </vue-json-to-csv>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
  import SearchTabs from "./FindBooking";
  import VueJsonToCsv from "vue-json-to-csv";
  export default {
    components: { SearchTabs, VueJsonToCsv },
    name: "BookingsAlert",
    data() {
      return {
        search: "",
        page: 2,
        update_alert_dialog: false,
        alert_updates: false,
        term: {
          key: "",
        },
        columns: [
          {
            text: "Booking Reference",
            value: "booking_ref",
          },
          {
            text: "Destination",
            value: "destination",
          },
          {
            text: "Adult",
            value: "adult",
          },
          {
            text: "Children",
            value: "children",
          },
          {
            text: "Vehicle Registration",
            value: "vehicle_registration",
          },
          {
            text: "Alert",
            value: "note",
          },
          {
            text: "Alert Date",
            value: "created_at",
          },
          {
            text: "Action Taken",
            value: "action_taken",
          },
          {
            text: "Action",
            value: "",
          },
        ],
        pagination: {
          rowsPerPage: 10
        },
        rowsPerPageItems: [10, 30, { text: 'All', value: -1 }],
      };
    },
    created() {
      this.$store.dispatch("get_unticketed_alert");
    },
    methods: {
      formated_date(date) {
        return this.$moment(date).format("YYYY-MM-DD");
      },
      updateViewAlertUpdate: function (note_id) {
        this.$router.push({
          name: "ViewUpdateAlert",
          params: {
            note_id: note_id,
          },
        });
      },
      searchTerm: function () {
        this.$store.dispatch("search_inspect_booking_by_key", this.term);
      },
      getUnticketed: function () {
        this.$store.dispatch("get_unticketed_alert");
      },
      getAlerts: function () {
        this.$router.push({
          name: "BookingsAlert",
        });
      },
      getMore() {
        this.loading = true;
        let data = {
          page: this.page,
        };
        if (this.page === 2) {
          this.$store.dispatch("get_more_unticketed_alert", data);
          this.page = this.page + 1;
        } else {
          this.$store.dispatch("get_more_unticketed_alert", data);
          this.page = this.page + 1;
        }
      },
      getAllUnticketedAlerts() {
        this.loading = true;
        let data = {
          page: 0,
        };
        this.$store.dispatch("get_more_unticketed_alert", data);
      },
    },
    computed: {
      getInspectedUnticketedAlerted() {
        return this.$store.state.BookingStore.inspection_unticketed_alerted_bookings || [];
      },
      getInspectedUnticketedCSV: function () {
        let all_notes =
          this.$store.state.BookingStore.inspection_unticketed_alerted_bookings;
        let notes_arr = [];
        if (all_notes == undefined) {
          return [];
        } else {
          for (let i = 0; i < all_notes.length; i++) {
            let notes_obj = {};
            notes_obj["destination"] = all_notes[i].destination;
            notes_obj["adult"] = all_notes[i].adult;
            notes_obj["children"] = all_notes[i].children;
            notes_obj["vehicle_registration"] = all_notes[i].vehicle_registration;
            notes_obj["note"] = all_notes[i].note;
            notes_obj["created_at"] = this.formated_date(all_notes[i].created_at);
            notes_obj["session_user"] = all_notes[i].session_user;
            let updates = all_notes[i].update_notes;
            let updates_arr = [];
            if (updates.length > 0) {
              for (let j = 0; j < updates.length; j++) {
                updates_arr.push(updates[j].alert_update);
              }
            }
            notes_obj["update_notes"] = updates_arr;
            notes_arr.push(notes_obj);
          }
          return notes_arr;
        }
      },
    },
  };
</script>

<style scoped>
  /* Futuristic Container */
  .payment-container {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    transition: all 0.3s ease;
  }

    .payment-container:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  .card-header {
    background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
    padding: 16px;
    border-radius: 8px;
  }

  .earth-color {
    color: #587e27;
    font-weight: 600;
    margin: 0;
    font-size: 1.5rem;
  }

  .title-decoration {
    height: 4px;
    background: linear-gradient(90deg, #587e27, transparent);
    margin-bottom: 16px;
    width: 100px;
  }

  .futuristic-card {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-card:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  .futuristic-expansion {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.3s ease;
  }

    .futuristic-expansion:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

  .futuristic-input > > > .v-input__slot {
    border-radius: 8px;
    background: #f5f7fa;
  }

  .futuristic-btn {
    border-radius: 8px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.2s ease;
  }

    .futuristic-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

  .futuristic-table {
    border-radius: 8px;
    background: #ffffff;
  }

    .futuristic-table > > > th {
      color: #587e27;
      font-weight: 600;
    }

  .futuristic-link {
    color: #587e27;
    text-decoration: none;
    transition: color 0.2s ease;
  }

    .futuristic-link:hover {
      color: #1b5e20;
    }

  .futuristic-alert {
    border-radius: 8px;
    background: #fff5f5;
  }

  .futuristic-search > > > .v-input__slot {
    border-radius: 8px;
    background: #f5f7fa;
  }

  /* Responsive adjustments */
  @media (max-width: 960px) {
    .payment-container {
      padding: 12px;
    }

    .card-header {
      padding: 12px;
    }

    .earth-color {
      font-size: 1.25rem;
    }

    .futuristic-btn {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 600px) {
    .payment-container {
      padding: 8px;
      border-radius: 6px;
    }

    .card-header {
      padding: 8px;
    }

    .earth-color {
      font-size: 1.1rem;
    }

    .futuristic-btn {
      font-size: 0.85rem;
    }
  }
</style>
